
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Logs from '@/components/usersettings/Logs.vue'
import AuthModule from '@/store/auth.module';

export default defineComponent({
    name: 'LogsDialog',
    components: { Logs },
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const { t } = useI18n({ useScope: 'global' })
        const height = ref(window.innerHeight * 0.5) // начальная высота — 50% экрана
        let startY = 0
        let startHeight = 0
        const logsKey = ref(0)
        const closeDialog = () => {

            if (AuthModule.currentUser) {
                AuthModule.updateSessionDebug({
                    username: AuthModule.currentUser.username,
                    debug: false
                })
            }
            logsKey.value++
            emit('update:modelValue', false)
        }

        const onDrag = (e: MouseEvent | TouchEvent) => {
            let clientY = 'touches' in e ? e.touches[0].clientY : e.clientY
            const newHeight = startHeight - (clientY - startY)
            height.value = Math.max(100, Math.min(newHeight, window.innerHeight * 0.9)) // min 100px, max 90% экрана
        }

        const stopDrag = () => {
            window.removeEventListener('mousemove', onDrag)
            window.removeEventListener('mouseup', stopDrag)
            window.removeEventListener('touchmove', onDrag)
            window.removeEventListener('touchend', stopDrag)
        }

        const startDrag = (e: MouseEvent | TouchEvent) => {
            startY = 'touches' in e ? e.touches[0].clientY : e.clientY
            startHeight = height.value
            window.addEventListener('mousemove', onDrag)
            window.addEventListener('mouseup', stopDrag)
            window.addEventListener('touchmove', onDrag)
            window.addEventListener('touchend', stopDrag)
        }

        return { t, height, startDrag, closeDialog,logsKey }
    }
})
